"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataExport = void 0;
const format_1 = __importDefault(require("date-fns/format"));
const helpers_1 = require("../helpers");
const slickgrid_1 = require("slickgrid");
const DEFAULTS = {
    timestampFormat: 'yyyyMMdd-hhmm'
};
class DataExport {
    pluginName = 'DataExport';
    eventHandler;
    grid;
    options;
    onDataExporting;
    constructor(options) {
        this.eventHandler = new slickgrid_1.SlickEventHandler();
        this.options = { ...DEFAULTS, ...options };
        this.onDataExporting = new slickgrid_1.SlickEvent();
    }
    init(grid) {
        this.grid = grid;
    }
    destroy() {
        this.eventHandler.unsubscribeAll();
    }
    async exportData(format, locale = null) {
        try {
            this.onDataExporting.notify({ status: true });
            return await (0, helpers_1.saveData)(this.grid, this.options.getDataItems(true), this.getFilename(format), 'csv', {
                delimiter: this.options.delimiter,
                quoteChar: this.options.quoteChar,
                localeCode: locale || this.options.localeCode
            });
        }
        catch (error) {
            console.error(error);
        }
        finally {
            this.onDataExporting.notify({ status: false });
        }
    }
    getFilename(extension) {
        let ts = '';
        if (this.options.timestampFormat) {
            ts = '-' + (0, format_1.default)(new Date(), this.options.timestampFormat);
        }
        return `${this.options.filename}${ts}.${extension}`;
    }
}
exports.DataExport = DataExport;
//# sourceMappingURL=DataExport.js.map